import WelcomeScreen from 'components/wizard/welcome-screen'
import WizardStepper from 'components/wizard/wizard-stepper'
import AcceptEUSAScreen from 'components/wizard/eusa-accept'
import { BrowserRouter, Routes, Route } from 'react-router'

export default function RegistrationWizard({ partner }) {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/wizardStepper"
          element={<WizardStepper partner={partner} />}
        />
        <Route path="/welcomeScreen" element={<WelcomeScreen />} />
        <Route path="/" element={<AcceptEUSAScreen />} />
        <Route path="*" element={<AcceptEUSAScreen />} />
      </Routes>
    </BrowserRouter>
  )
}
